export default __webpack_public_path__ + "static/media/LaMichoacana.cfba0ba9.png";